import React from 'react'
import { Link } from 'gatsby'
import { resolvePath } from '../utils/helpersClient.js'

const CustomLink = (props) => {
  const { link, ...propsWithClassName} = props
  const { className, ...propsWithoutClassName} = propsWithClassName
  return (
    <>
      {!!props.link && 
        <>
          {(props.link && (props.link.substring(0, 4) != 'http' && props.link.substring(0, 8) != '/static/')) ? 
            <Link to={resolvePath(props.link)} {...propsWithClassName}>{props.children}</Link>
          : 
            <a href={props.link} className={(props.className === undefined ? `effect` : props.className + (props.className.indexOf("effect") == -1 ? ` effect` : ``))} {...propsWithoutClassName} target="_blank" rel="noopener">{props.children}</a>
          }
        </>
      }
    </>
  )
}
export default CustomLink